import MainHeading from "../typeComponents/MainHeading";
import TextBlock from "../typeComponents/TextBlock";
import Paragraph from "../typeComponents/Paragraph";
import { Box } from "@mui/material";
import CureLogoCleanVector from "../images/CURE_logo_clean_vector.svg";

const Strategy = () => {
  return (
    <TextBlock>
      <MainHeading>Free Strategic Consulting For Students!</MainHeading>
      <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
        <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
      </Box>
      <Paragraph>
        CURE has been successfully organizing community projects and events for
        Concordia students since 2016. We've made cool projects a reality,
        figured out tough research questions, organized events, and even landed
        big external funding!
      </Paragraph>
      <Paragraph>
        If you're trying to get a project off the ground and have questions
        about making it work, we'd love to chat and see if we can help!
      </Paragraph>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdVGnZz0X1AG_RIJ5LPtmrFfFC1GRiM_2Ygh2mdtBopGekZRg/viewform?usp=sharing"
        title="CURE 2025 Strategic Consulting Intake Form"
        width="100%"
        height="2400"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </TextBlock>
  );
};
export default Strategy;
